<template>
	<div class=" " style="height: 100vh;">
		<hedBox @canvasFn="canvasFn" @onEditer="onEditer"></hedBox>
		<!-- 工作区 -->
		<div v-loading="pageloading.show" element-loading-custom-class="custom-loading" :element-loading-text="pageloading.text"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)"
			class="work-content flex_c_s" style="overflow-y: auto;height:calc(100vh - 58px)">
			<!-- style="overflow-y: scroll" -->
			<!-- 组件库 -->
			<Components @handleClickItem="onAddItem" />
			<!--手机容器-->
			<!-- overflow-y: scroll; -->
			<div class="preview-wrap flex1 base_form_height" style="
          overflow-y: scroll;
          display: flex;
          align-items: center;
          justify-content: center;
        ">
				<Phone ref="phone" v-if="!isLoading" :data="data" :selectedIndex="selectedIndex" @onEditer="onEditer"
					@onActionItem="onActionItem" @uploadImgMallDecoration="uploadImgMallDecoration" />
			</div>
			<!-- 编辑器 -->
			<div class="edit">
				<Editor v-if="!isLoading" :defaultData="defaultData" :data="data" :selectedIndex="selectedIndex"
					:curItem="curItem" />
			</div>
		</div>
		<!-- 操作栏 -->
		<!-- <div class="base_fixed_bottom">
			<el-button class="base_grey_but base_but_style base_return_but" type="info" plain
				@click="toback">返回</el-button>

			<el-button class="base_but_style base_save_but" type="primary" @click="canvasFn">保存</el-button>
		</div> -->
	</div>
</template>

<script>
	// import _ from 'lodash'
	import draggable from "vuedraggable";
	// import { inArray } from '@/utils/util'
	// import * as Api from '@/api/page'
	// import { SelectImage } from '@/components'
	import hedBox from "./components/head.vue";
	import {
		Phone,
		Components,
		Editor
	} from "./modulesuser";
	import {
		eltips
	} from "@/util/util.js";

	export default {
		components: {
			Components,
			hedBox,
			Phone,
			Editor,
		},
		data() {
			return {
				pageloading: {
					show: false,
					text: '加载中'
				},
				isSumbit: true,
				crumbs: [],
				// 页面类型
				// pageType: pageTypes[this.$route.path],
				// loading状态
				isLoading: false,
				// 页面装修默认数据
				defaultData: {
					page: {
						params: {
							name: "页面名称",
							title: "页面标题",
							shareTitle: "分享标题",
							model_type: '0',
							shareImg: "", //封面地址
							searchTips: "搜索商品名称",
							bgstyle: 1,
							storeShow: 1,
							searchShow: 1
						},
						style: {
							zubackground: "#f9f9f9",
							titleTextColor: "black",
							titleBackgroundColor: "#ffffff",
							titleBackgroundImg: "",
							searchTextColor: "#000000",
							searchBackgroudColor: "#f9f9f9",
							searchTitTextColor: "#000000",
							backgroundPage: '#f9f9f9'
						},
					},
					items: {
						search: {
							name: "搜索框",
							icon: require("@/assets/page/icon/search.png"),
							type: "search",
							params: {
								placeholder: "请输入关键字进行搜索",
								sticky: false,
							},
							style: {
								zubackground: "#f9f9f9",
								textAlign: "left",
								searchStyle: "square",
								background: "#fff",
								color: "#000",
								borderColor: "#000",
								paddingTop: 10,
								paddingBottom: 10,
								paddingRight: 10,
								paddingLeft: 10,
								radiusTop: 0,
								radiusBottom: 0
							},
						},
						banner: {
							name: "图片轮播",
							icon: require("@/assets/page/icon/banner.png"),
							type: "banner",
							params: {
								dot: 1
							},
							style: {
								zubackground: "#f9f9f9",
								btnColor: "#ffffff",
								btnShape: "round",
								interval: 2.5,
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								borderRadius: 10,
								background: "#fff",
							},
							data: [{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg ",
									imgName: "image-1.jpg",
									link: null,
									width: 0,
									height: 0
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg ",
									imgName: "image-1.jpg",
									link: null,
									width: 0,
									height: 0
								},
							],
						},
						balance: {
							name: "余额",
							icon: require("@/assets/page/icon/banner.png"),
							type: "balance",
							params: {
								but:'立即充值',
								title:'储值余额',
								icon:'',
								money:'元'
							},
							style: {
								zubackground: "#f9f9f9",
								background: "#ffffff",
								btnBg: "#000000",
								btnRadius: 10,
								btnColor: "#ffffff",
								btnFont: 12,
								titleColor: "#000000",
								titleFont: 12,
								subColor: "#000000",
								subFont: 12,
								moneyColor: "#000000",
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								borderRadius: 10,
							}
						},
						pointeroffline: {
							name: "线下取积分",
							icon: require("@/assets/page/icon/banner.png"),
							type: "pointeroffline",
							params: {
								but:'取线下积分',
								title:'我的积分'
							},
							style: {
								zubackground: "#f9f9f9",
								background: "#ffffff",
								btnBg: "#000",
								btnColor: "#ffffff",
								btnRadius: 10,
								btnFont: 12,
								titleColor: "#000000",
								titleFont: 12,
								moneyColor: "#000000",
								moneyFont: 20,
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								borderRadius: 10,
							}
						},
						image: {
							name: "图片",
							icon: require("@/assets/page/icon/image.png"),
							type: "image",
							style: {
								zubackground: "#f9f9f9",
								paddingTop: 0,
								paddingLeft: 0,
								background: "#ffffff",
								borderRadius: 10,
							},
							data: [{
								imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg ",
								imgName: "image-1.jpg",
								link: null,
							}, ],
						},
						navBar: {
							name: "导航组",
							icon: require("@/assets/page/icon/navBar.png"),
							type: "navBar",
							params: {
								interactive: 2,
								rowNum: 2
							},
							style: {
								zubackground: "#f9f9f9",
								rowsNum: 4,
								background: "#ffffff",
								paddingTop: 0,
								textColor: "#666666",
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								borderRadius: 10,
								borderRadius1: 10,
								navRadius: 1
							},

							data: [{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-1.png",
									link: null,
									text: "按钮文字1",
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-2.jpg",
									link: null,
									text: "按钮文字2",
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-3.jpg",
									link: null,
									text: "按钮文字3",
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-4.jpg",
									link: null,
									text: "按钮文字4",
								},
							],
						},
						modulelise: {
							name: "列表导航",
							icon: require("@/assets/page/icon/navBar.png"),
							type: "modulelise",
							params: {
								imgshow: 1,
							},
							style: {
								zubackground: "#f9f9f9",
								background: "#ffffff",
								bordercolor: "#f9f9f9",
								textColor: "#000",
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								borderRadius: 10,
								lineheight: 10
							},
							data: [{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-1.png",
									link: null,
									text: "按钮文字1",
									smalltext: ''
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-2.jpg",
									link: null,
									text: "按钮文字2",
									smalltext: ''
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-3.jpg",
									link: null,
									text: "按钮文字3",
									smalltext: ''
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-4.jpg",
									link: null,
									text: "按钮文字4",
									smalltext: ''
								},
							],
						},
						modulebut: {
							name: "按钮组",
							icon: require("@/assets/page/icon/navBar.png"),
							type: "modulebut",
							params: {
								imgshow: 1,
							},
							style: {
								zubackground: "#f9f9f9",
								background: "#ffffff",
								bordercolr: "#f9f9f9",
								textColor: "#666666",
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								borderRadius: 10
							},
							data: [{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-1.png",
									link: null,
									text: "按钮1",
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-2.jpg",
									link: null,
									text: "按钮2",
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-3.jpg",
									link: null,
									text: "按钮3",
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-4.jpg",
									link: null,
									text: "按钮4",
								},
							],
						},
						moduleimg: {
							name: "图标组",
							icon: require("@/assets/page/icon/navBar.png"),
							type: "moduleimg",
							params: {
								interactive: 2,
								rowNum: 2,
								title: '我的服务'
							},
							style: {
								titlefont: 14,
								titleweight: 2,
								titlecolor: '#000',
								zubackground: "#f9f9f9",
								rowsNum: 4,
								background: "#ffffff",
								paddingTop: 0,
								textColor: "#666666",
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								borderRadius: 10,
								borderRadius1: 10,
								navRadius: 1
							},

							data: [{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-1.png",
									link: null,
									text: "按钮文字1",
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-2.jpg",
									link: null,
									text: "按钮文字2",
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-3.jpg",
									link: null,
									text: "按钮文字3",
								},
								{
									imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									imgName: "icon-4.jpg",
									link: null,
									text: "按钮文字4",
								},
							],
						},
						orderimg: {
							name: "订单图标组",
							icon: require("@/assets/page/icon/navBar.png"),
							type: "orderimg",
							params: {},
							style: {
								zubackground: "#f9f9f9",
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								borderRadius: 10,
								borderRadius1: 10
							},
							data: [{
									imgUrl: "https://mp.mocols.com/common/weishop/order/i_pay.png",
									link: 'payment',
									text: "待支付",
									pla: '待支付'
								},
								{
									imgUrl: "https://mp.mocols.com/common/weishop/order/i_send.png",
									link: 'delivery',
									text: "待发货",
									pla: "待发货",
								},
								{
									imgUrl: "https://mp.mocols.com/common/weishop/order/i_in.png",
									link: 'received',
									text: "待收货",
									pla: "待收货",
								},
								{
									imgUrl: "https://mp.mocols.com/common/weishop/order/i_calulate.png",
									link: 'comment',
									text: "待评价",
									pla: "待评价",
								},
								{
									imgUrl: "https://mp.mocols.com/common/weishop/order/i_return.png",
									link: 'refund',
									url: 'pages/other/refund/index',
									text: "退换/售后",
									pla: "退换/售后",
								},
							],
						},
						blank: {
							name: "辅助空白",
							icon: require("@/assets/page/icon/blank.png"),
							type: "blank",
							style: {
								zubackground: "#f9f9f9",
								height: 20,
								background: "#f9f9f9",
							},
						},
						userhead: {
							name: "会员信息",
							icon: require("@/assets/page/icon/blank.png"),
							type: "userhead",
							params: {
								type: "1",
								level: ['member', 'distribution'],
								but: ["balance", "points", "coupon", "contribution", "life"]
							},
							style: {
								show: ['set', 'service'],
								background: "#ffffff",
								backgroundimg: 'https://mp.mocols.com/common/weishop/mine/head_bg.jpg',
								namecolor: "#000",
								levelimg: "https://mp.mocols.com/common/weishop/icon/icon_vip.png",
								levelcolor: "#fff",
								levelbg: "#000",
								distributionimg: "https://mp.mocols.com/common/weishop/mine/levelmeber.png",
								distributioncolor: "#fff",
								distributionbg: "#000",
								setimg: "https://mp.mocols.com/common/weishop/order/setting.png",
								serviceimg: "https://mp.mocols.com/common/weishop/order/wchat.png",
								financenum: '#f00',
								financetext: '#999'
							},
						},
						modulepay: {
							name: "会员VIP",
							icon: require("@/assets/page/icon/blank.png"),
							type: "modulepay",
							params: {
								type: "1",
								title: 'VIP会员',
								tips: '开通会员·专属特权'
							},
							style: {
								zubackground: "#f9f9f9",
								background: '#f00',
								backgroundimg: 'https://mp.mocols.com/common/weishop/vip/vip_bg.jpg',
								color: "#6E2200",
								icon: "https://mp.mocols.com/common/weishop/vip/vip_logo.png",
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								borderRadius: 10
							},
						},
						guide: {
							name: "辅助线",
							type: "guide",
							icon: require("@/assets/page/icon/guide.png"),
							params: {
								source: "auto",
								auto: {
									category: -1,
									showNum: 6,
								},
							},
							style: {
								zubackground: "#f9f9f9",
								background: "#f9f9f9",
								lineStyle: "solid",
								lineHeight: 1,
								lineColor: "#000000",
								paddingTop: 10,
								paddingLeft: 10,
							},
						},

						article: {
							name: "文章组",
							icon: require("@/assets/page/icon/article.png"),
							type: "article",
							params: {
								source: "auto",
								auto: {
									category: -1,
									showNum: 6,
								},
							},
							defaultData: [{
									title: "此处显示文章标题",
									show_type: 10,
									image: "https://mp.mocols.com/common/admin/admin_banner.jpg ",
									views_num: 309,
								},
								{
									title: "此处显示文章标题",
									show_type: 10,
									image: "https://mp.mocols.com/common/admin/admin_banner.jpg ",
									views_num: 309,
								},
							],
							data: [],
						},
						notice: {
							name: "店铺公告",
							icon: require("@/assets/page/icon/notice.png"),
							type: "notice",
							params: {
								text: "这里是第一条自定义公告的标题",
								link: null,
								showIcon: true,
								scrollable: true,
							},
							style: {
								zubackground: "#f9f9f9",
								paddingTop: 0,
								paddingLeft: 0,
								radiusTop: 0,
								radiusLeft: 0,
								background: "#fffbe8",
								textColor: "#de8c17",
							},
						},
						richText: {
							name: "富文本",
							icon: require("@/assets/page/icon/richText.png"),
							type: "richText",
							params: {
								content: "<p>这里是文本的内容</p>",
							},
							style: {
								zubackground: "#f9f9f9",
								paddingLeft: 0,
								paddingRight: 0,
								paddingBottom: 0,
								paddingTop: 0,
								background: "#ffffff",
							},
						},
						window: {
							name: "图片橱窗",
							icon: require("@/assets/page/icon/window.png"),
							type: "window",
							style: {
								zubackground: "#f9f9f9",
								paddingTop: 0,
								paddingLeft: 0,
								background: "#ffffff",
								layout: 2,
							},
							data: [{
									imgUrl: "https://qiniuyun.mocols.com/upload/images/20250314/202503141614393368.jpg",
									link: null,
								},
								{
									imgUrl: "https://qiniuyun.mocols.com/upload/images/20250314/202503141614395417.jpg",
									link: null,
								},
								{
									imgUrl: "https://qiniuyun.mocols.com/upload/images/20250314/202503141614398588.jpg",
									link: null,
								},
								{
									imgUrl: "https://qiniuyun.mocols.com/upload/images/20250314/202503141614394271.jpg",
									link: null,
								},
							],
							dataNum: 4,
						},
						hotZone: {
							name: "热区",
							icon: require("@/assets/page/icon/hotZone.png"),
							type: "hotZone",
							style: {
								zubackground: "#f9f9f9",
								paddingTop: 0,
								paddingLeft: 0,
								paddingRight: 0,
								paddingBottom: 0,
								background: "#ffffff",
								radiusTop: 0,
								radiusBottom: 0
							},
							data: {
								imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg ",
								imgName: "image-1.jpg",
								maps: [{
									width: 300,
									height: 100,
									left: 0,
									top: 0,
									link: null,
									key: 1,
								}, ],
							},
						},
						goods: {
							name: "商品组",
							icon: require("@/assets/page/icon/goods.png"),
							type: "goods",
							params: {
								source: "auto",
								auto: {
									category: 0,
									goodsSort: "all",
									showNum: 6,
								},
							},
							style: {
								zubackground: "#f9f9f9",
								display: "list",
								column: 2,
								show: [
									"goodsName",
									"goodsPrice",
									"linePrice",
									"sellingPoint",
									"goodsSales",
									"cartBtn",
								],
								swipter: 2,
								priceColor: "#FF0000",
								sellingColor: "#e3771f",
								goodsNameRows: "two",
								goodsWeight: "normal",
								goodsSize: 15,
								btnCartStyle: 1,
								btnCartColor: "#FF0000",
								cardType: "card",
								borderRadius: 10,
								itemMargin: 10,
								background: "#f9f9f9",
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								hotTag:'2'
							},
							defaultData: [{
									goods_name: "此处显示商品名称",
									goods_image: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									goods_price_min: "99.00",
									line_price_min: "139.00",
									selling_point: "此款商品美观大方 不容错过",
									goods_sales: 100,
								},
								{
									goods_name: "此处显示商品名称",
									goods_image: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									goods_price_min: "99.00",
									line_price_min: "139.00",
									selling_point: "此款商品美观大方 不容错过",
									goods_sales: 100,
								},
								{
									goods_name: "此处显示商品名称",
									goods_image: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									goods_price_min: "99.00",
									line_price_min: "139.00",
									selling_point: "此款商品美观大方 不容错过",
									goods_sales: 100,
								},
								{
									goods_name: "此处显示商品名称",
									goods_image: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									goods_price_min: "99.00",
									line_price_min: "139.00",
									selling_point: "此款商品美观大方 不容错过",
									goods_sales: 100,
								},
							],
							swipter: [{
								imgUrl: "https://mp.mocols.com/common/admin/admin_banner.jpg ",
								imgName: "image-1.jpg",
								link: null,
							}],
							data: [{
									goods_name: "此处显示商品名称",
									goods_image: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									goods_price_min: "99.00",
									line_price_min: "139.00",
									selling_point: "此款商品美观大方 不容错过",
									goods_sales: 100,
								},
								{
									goods_name: "此处显示商品名称",
									goods_image: "https://mp.mocols.com/common/admin/admin_banner.jpg",
									goods_price_min: "99.00",
									line_price_min: "139.00",
									selling_point: "此款商品美观大方 不容错过",
									goods_sales: 100,
								},
							],
						},
						service: {
							name: "在线客服",
							icon: require("@/assets/page/icon/service.png"),
							type: "service",
							params: {
								type: "chat",
								image: "https://mp.mocols.com/common/weishop/service_img.png",
								tel: "",
							},
							style: {
								zubackground: "#f9f9f9",
								right: 1,
								bottom: 30,
								opacity: 100,
								width: 50,
								height: 50
							},
						},
						modulephone: {
							name: "绑定手机",
							icon: require("@/assets/page/icon/service.png"),
							type: "modulephone",
							params: {
								image: "https://mp.mocols.com/common/weishop/service_img.png",
								text: "绑定手机号获取更多信息",
								buttext: "立即绑定"
							},
							style: {
								zubackground: "#f9f9f9",
								background: "#ffffff",
								textColor: "#666666",
								butColor: "#fff",
								butground: "#006aff",
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10,
								borderRadius: 10,
								borderRadius1: 10
							},
						},
						officialAccount: {
							name: "关注公众号",
							icon: require("@/assets/page/icon/officialAccount.png"),
							type: "officialAccount",
							params: [],
							style: [],
						},
						special: {
							name: "头条快报",
							icon: require("@/assets/page/icon/special.png"),
							type: "special",
							params: {
								source: "auto",
								auto: {
									category: -1,
									showNum: 6,
								},
								display: 1,
								image: "https://qiniuyun.mocols.com/upload/images/20250314/202503141426106284.png",
							},
							style: {
								zubackground: "#f9f9f9",
								background: "#ffffff",
								textColor: "#141414",
								paddingTop: 0,
							},
							defaultData: [{
									title: "张小龙4小时演讲：你和高手之间，隔着“简单”二字",
								},
								{
									title: "张小龙4小时演讲：你和高手之间，隔着“简单”二字",
								},
							],
							data: [],
						},
						title: {
							name: "标题文本",
							icon: require("@/assets/page/icon/title.png"),
							type: "title",
							params: {
								title: "这是标题",
								desc: "这里是描述",
								titleFontSize: 15,
								titleFontWeight: "bold",
								descFontSize: 12,
								descFontWeight: "normal",
								more: {
									enable: true,
									text: "查看更多",
									enableIcon: true,
									link: null,
								},
							},
							style: {
								zubackground: "#f9f9f9",
								titleTextColor: "#323233",
								descTextColor: "#969799",
								moreTextColor: "#969799",
								background: "#f9f9f9",
								paddingY: 10,
								paddingY1: 10,
								paddingX: 10,
								paddingX1: 10
							},
						}
					},
				},
				// 当前页面数据
				data: {
					page: {
						params: {
							name: "页面名称",
							title: "页面标题",
							shareTitle: "分享标题",
							is_open: 0,
							adsList: [],
							password: "",
							model_type: '0',
							searchTips: "搜索商品名称"
						},
						style: {
							zubackground: "#f9f9f9",
							titleTextColor: "black",
							titleBackgroundColor: "#ffffff",
							searchTextColor: "#000",
							searchBackgroudColor: "#f9f9f9",
							searchTitTextColor: "#000",
							backgroundPage: '#f9f9f9'
						},
					},
					items: [
						// {
						//   name: "图片轮播",
						//   type: "banner",
						//   style: {
						//     btnColor: "#ffffff",
						//     btnShape: "round",
						//     interval: 2.5,
						//   },
						//   icon: require("@/assets/page/icon/banner.png"),
						//   data: [
						//     {
						//       imgUrl:
						//         "https://mp.mocols.com/common/admin/admin_banner.jpg ",
						//       imgName: "image-1.jpg",
						//       link: null,
						//     },
						//     {
						//       imgUrl:
						//         "https://mp.mocols.com/common/admin/admin_banner.jpg ",
						//       imgName: "image-1.jpg",
						//       link: null,
						//     },
						//   ],
						// },
						// {
						//   name: "图片轮播",
						//   type: "banner",
						//   icon: require("@/assets/page/icon/banner.png"),
						//   style: {
						//     btnColor: "#ffffff",
						//     btnShape: "round",
						//     interval: 2.5,
						//   },
						//   data: [
						//     {
						//       imgUrl:
						//         "https://mp.mocols.com/common/admin/admin_banner.jpg ",
						//       imgName: "image-1.jpg",
						//       link: null,
						//     },
						//     {
						//       imgUrl:
						//         "https://mp.mocols.com/common/admin/admin_banner.jpg ",
						//       imgName: "image-1.jpg",
						//       link: null,
						//     },
						//   ],
						// },
					],
				},
				// 当前选中的元素索引
				selectedIndex: "page",
				// 当前选中的元素
				curItem: {},
				// 当前页面ID
				pageId: null,
				// 传递过来的所有数据
				getData: {},
			};
		},
		// 初始化数据
		created() {
			// 记录页面ID
			this.pageId = this.$route.query.pageId;
			this.crumbs = this.$route.query.crumbs;
			// 获取初始化数据
			// this.initData()
			if (this.$route.query.id) {
				this.getPageData();
			}
		},
		methods: {
			// 获取页面详情
			getPageData() {
				this.isLoading = true;
				let _this = this;
				_this.axios
					.get("/api/weishop/admin/store/page/detail/" + _this.$route.query.id)
					.then((res) => {
						if (res.code == 200) {
							if (!res.data.page_data.page.params.adsList) {
								res.data.page_data.page.params.adsList = []
							}
							res.data.page_data.items.map(refg => {
								if (refg.type == "navBar") {
									refg.style.navRadius = refg.style.navRadius ? refg.style.navRadius : 1
									if (!refg.params) {
										refg.params = {
											interactive: 2,
											rowNum: 2
										}
									}
								}
								if (refg.type == "goods") {
									refg.swipter = refg.swipter ? refg.swipter : []
									refg.style.swipter = refg.style.swipter ? refg.style.swipter : 2
								}
								if (refg.type == "stores") {
									refg.params = refg.params ? refg.params : {
										style: 1
									}
								}
								if (refg.type == "banner") {
									refg.params = refg.params ? refg.params : {
										dot: 1
									}
								}
								return refg
							})
							this.data = res.data.page_data;
							this.getData = res.data;

							this.isLoading = false;
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			// 获取初始化数据
			initData() {
				this.isLoading = true;
				Promise.all([
					// 获取默认数据
					this.getDefaultData(),
					// 获取当前页面数据
					this.pageType.name != "create" && this.getPageData(),
				]).then(() => {
					// 生成默认的data
					this.pageType.name == "create" && this.createNewData();
					this.isLoading = false;
				});
			},

			// 生成默认的data
			createNewData() {
				const {
					defaultData,
					data
				} = this;
				data.page = defaultData.page;
				data.items = [];
			},

			// 获取默认数据
			getDefaultData() {
				return new Promise((resolve, reject) => {
					Api.defaultData().then((result) => {
						this.defaultData = result.data;
						resolve();
					});
				});
			},

			// 获取当前页面数据
			// getPageData() {
			//   const { pageId } = this;
			//   return new Promise((resolve, reject) => {
			//     Api.detail({ pageId }).then((result) => {
			//       this.data = result.data.detail.page_data;
			//       resolve();
			//     });
			//   });
			// },

			/**
			 * 新增Diy组件
			 * @param type
			 */
			onAddItem(type) {
				// 验证新增Diy组件
				if (!this.onCheckAddItem(type)) {
					return false;
				}
				const {
					defaultData,
					data
				} = this;
				// 复制默认diy组件数据
				const newItem = _.cloneDeep(defaultData.items[type]);
				// 新增到diy列表数据
				// 如果当前有选中则在当前选中下面新增
				if (this.selectedIndex != "page") {
					if (newItem.type == "userhead") {
						data.items.unshift(newItem);
					} else {
						data.items.splice(this.selectedIndex + 1, 0, newItem);
					}
					this.onEditer(this.selectedIndex + 1);
				} else {
					if (newItem.type == "userhead") {
						data.items.unshift(newItem);
					} else {
						data.items.push(newItem);
					}
					this.onEditer(data.items.length - 1);
				}
				// 编辑当前选中的元素
			},

			/**
			 * 验证新增Diy组件
			 * @param type
			 */
			onCheckAddItem(type) {
				const {
					data
				} = this;
				// 验证关注公众号组件只能存在一个
				if (type === "officialAccount") {
					const itemsTypes = data.items.map((item) => item.type);
					if (this.$util.inArray(type, itemsTypes)) {
						this.$message.warning("该组件最多存在一个");
						return false;
					}
				}
				//验证用户信息组件只能存在一个
				if (type === "userhead") {
					const itemsTypes = data.items.map((item) => item.type);
					if (this.$util.inArray(type, itemsTypes)) {
						this.$message.warning("该组件最多存在一个");
						return false;
					}
				}
				return true;
			},

			/**
			 * 编辑当前选中的Diy元素
			 * @param index
			 */
			onEditer(index) {
				const {
					data
				} = this;
				// 记录当前选中元素的索引
				this.selectedIndex = index;
				// 当前选中的元素数据
				this.curItem = index === "page" ? data.page : data.items[index];
			},

			// 操作工具栏事件
			onActionItem(type, index) {
				const methods = {
					"el-icon-top": "onUpItem",
					"el-icon-bottom": "onDownItem",
					"el-icon-document-copy": "onCopyItem",
					"el-icon-close": "onDeleleItem",
				};
				typeof this[methods[type]] === "function" && this[methods[type]](index);
			},

			/**
			 * 上移diy元素
			 * @param index
			 */
			onUpItem(index) {
				const {
					data: {
						items
					},
				} = this;
				const newIndex = index - 1;
				// 判断已经最顶
				if (index == 0) {
					return;
				}
				const item = items.splice(index, 1)[0];
				items.splice(newIndex, 0, item);
				if (this.selectedIndex == index) {
					this.selectedIndex = newIndex;
				}
			},

			/**
			 * 下移diy元素
			 * @param index
			 */
			onDownItem(index) {
				const {
					data: {
						items
					},
				} = this;
				const newIndex = index + 1;
				// 判断已经最底
				if (items.length <= newIndex) {
					return;
				}
				const item = items.splice(index, 1)[0];
				items.splice(newIndex, 0, item);
				if (this.selectedIndex == index) {
					this.selectedIndex = newIndex;
				}
			},

			/**
			 * 复制diy元素
			 * @param index
			 */
			onCopyItem(index) {
				const {
					data: {
						items
					},
				} = this;
				if (!this.onCheckAddItem(items[index].type)) {
					return false;
				}
				const newItem = _.cloneDeep(items[index]);
				items.splice(index, 0, newItem);
			},

			/**
			 * 删除diy元素
			 * @param index
			 */
			onDeleleItem(index) {
				const {
					data: {
						items
					},
				} = this;
				items.splice(index, 1);
				this.selectedIndex = -1;
			},

			/**
			 * 编辑器：重置颜色
			 * @param holder
			 * @param attribute
			 * @param color
			 */
			onEditorResetColor(holder, attribute, color) {
				holder[attribute] = color;
			},
			// 提交到后端api
			// onFormSubmit() {
			//   this.isLoading = true;
			//   const { pageId, data, $message, pageType } = this;
			//   pageType
			//     .apiMothod({ pageId, form: data })
			//     .then((result) => {
			//       // 显示成功
			//       $message.success(result.message, 1.5);
			//       // 跳转到列表页
			//       setTimeout(() => this.$router.push("./index"), 1500);
			//     })
			//     .finally(() => (this.isLoading = false));
			// },
			// 返回
			toback() {
				this.$router.go(-1);
			},
			getImageSize(url) {
				return new Promise((resolve, reject) => {
					const img = new Image();
					img.src = url;
					img.onload = () => {
						console.log(img)
						console.log(img.width)
						resolve({
							width: img.width,
							height: img.height
						});
					};
					img.onerror = reject;
				});
			},
			async getNewData() {
				let _this = this
				let ds = JSON.parse(JSON.stringify(_this.data))
				if (ds.items.length > 0) {
					await ds.items.map(async rej => {
						if (rej.type == 'banner') {
							if (rej.data.length > 0) {
								await rej.data.map(async red => {
									let wdh = await _this.getImageSize(red.imgUrl)
									red.width = wdh.width
									red.height = wdh.height
									return red
								})
								return rej
							}
						}
					})
					return ds
				} else {
					return ds
				}
			},
			// 点击新增/编辑页面-在返回成功的时候删除之前保存的图片
			async submitForm() {
				let _this = this;
				_this.pageloading.text = '页面保存中'
				let dsf = await _this.getNewData()
				setTimeout(function() {
					_this.axios
						.post(
							_this.$route.query.id ?
							"/api/weishop/admin/store/page/edit/" + _this.$route.query.id :
							"/api/weishop/admin/store/page/add", {
								form: {
									...dsf,
									page_type: 30
								}

							}
						)
						.then((res) => {
							_this.isSumbit = true
							_this.pageloading.show = false
							if (res.code == 200) {
								eltips(res.msg, "success");
								if (_this.$route.query.id && _this.getData.cover_id) {
									if (_this.data.page.params.cover_id != _this.getData.cover_id) {
										_this.dealImg();
									}
									// _this.toback();
								} else {
									_this.toback();
								}
							} else {
								eltips(res.msg, "error");
							}
						});
				}, 1500)

			},
			// 删除该页面之前的截图
			dealImg() {
				this.axios
					.delete("/api/common/asset/image-delete/" + this.getData.cover_id)
					.then((res) => {
						if (res.code == 200) {
							this.toback();
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			canvasFn() {
				if (this.isSumbit) {
					this.isSumbit = false
					this.pageloading.show = true
					this.pageloading.text = '缩略图生成中'
					this.$refs.phone.saveImag();
				} else {
					eltips('保存中，请耐心等待！', "error");
				}
			},
			async uploadImgMallDecoration(file) {
				this.pageloading.text = '缩略图上传中'
				let fileOfBlob = new File([file], new Date().getTime() + ".png");
				const formData = new FormData();
				formData.append("file[0]", fileOfBlob);
				formData.append("group_id", 0);
				formData.append("user_type", 1);
				this.axios.post("/api/common/upload-images", formData).then((res) => {
					if (res.code == 200) {
						this.data.page.params.cover_id = res.data.image_ids[0];
						this.submitForm();
					} else {
						eltips(res.msg, "error");
					}
				});
			},
		},
	};
</script>
<style lang="less" scoped>
	// @import './style.less';
	::v-deep .custom-loading .el-loading-spinner {
	  font-size: 30px; /* 控制图标的字体大小 */
	}
	.edit {
		width: 500px;
		align-self: flex-start;
	}
	.work-content{
		background-color: #f9f9f9;
	}
	// 修改phone组件滚动条样式
	/deep/::-webkit-scrollbar-thumb {
		background: none;
	}
</style>